import React, { useEffect, useState } from "react";
import { fetchApiGet, fetchApiPost } from "../utils/FetchApi";
import { ApiName } from "../utils/ApiName";
import tagManagerEvents from "../utils/GoogleTagManager";
import Awareness from "../pages/Awareness";

type Props = {
  token: string | null;
};

const AwarenessScreen = (props: Props) => {
  const [isHidden, setIsHidden] = useState(true);

  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  const utmSource: any = searchParams.get("utm_source");
  const qsPackageId = searchParams.get("package_id")
    ? searchParams.get("package_id")
    : "1";
  useEffect(() => {
    if (props.token) {
      getFlow(utmSource);
    }
  }, [props.token]);

  const getFlow = async (utmSource: string) => {
    try {
      let _qsPackageId = "1";
      if (qsPackageId === "1" || qsPackageId === "2" || qsPackageId === "3") {
        _qsPackageId = qsPackageId;
      }
      let data = {
        utm_source: utmSource,
        package_id: _qsPackageId,
      };
      let response = await fetchApiPost(
        props.token,
        ApiName.awarenessFlow,
        data
      );
      if (response.status === 0) {
        if (qsPackageId === "1") {
          tagManagerEvents("subscribe", "tiktok");
        } else if (qsPackageId === "2") {
          tagManagerEvents("subscribe", "tiktokWeekly");
        } else if (qsPackageId === "3") {
          tagManagerEvents("subscribe", "tiktokMonthly");
        } else {
          tagManagerEvents("subscribe", utmSource);
        }
        setIsHidden(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleOverLay = () => {
    setIsHidden(true);
  };

  return <Awareness isHidden={isHidden} handleOverLay={handleOverLay} />;
};

export default AwarenessScreen;
